import { createAction, props } from '@ngrx/store'
import { AppIdInput, CreateAppInput, UpdateAppInput } from '@papi/interfaces'
import { UsersPartnerApp } from './app.model'

export const createApp = createAction('[App] Create App', props<{ input: CreateAppInput }>())
export const createAppSuccess = createAction('[App] Create App Success')
export const createAppFailure = createAction('[App] Create App Failure', props<{ error: Error }>())
export const updateAppLogo = createAction('[App] Update App Logo', props<{ input: UpdateAppInput }>())
export const updateAppWebhookUrl = createAction('[App] Update App webhook', props<{ input: UpdateAppInput }>())
export const updateApp = createAction('[App] Update App', props<{ input: UpdateAppInput }>())
export const updateAppSuccess = createAction('[App] Update App Success')
export const updateAppFailure = createAction('[App] Update App Failure', props<{ error: Error }>())
export const deleteApp = createAction('[App] Delete App', props<{ input: AppIdInput }>())
export const deleteAppSuccess = createAction('[App] Delete App Success')
export const deleteAppFailure = createAction('[App] Delete App Failure', props<{ error: Error }>())
export const receivedApp = createAction('[App] Received App Update', props<{ app: UsersPartnerApp }>())
export const deletedApp = createAction('[App] Received App Delete', props<{ appId: string }>())
export const activateApp = createAction('[App] Activate App', props<{ appId: string }>())
export const activateAppSuccess = createAction('[App] Activate App Success', props<{ appId: string }>())
export const activateAppFailure = createAction('[App] Activate App Failure', props<{ error: Error }>())
export const deactivateApp = createAction('[App] Deactivate App', props<{ appId: string }>())
export const deactivateAppSuccess = createAction('[App] Deactivate App Success', props<{ appId: string }>())
export const deactivateAppFailure = createAction('[App] Deactivate App Failure', props<{ error: Error }>())
export const disconnectAccount = createAction('[App] Disconnect Account', props<{ appId: string; account: number }>())
export const disconnectAccountSuccess = createAction(
  '[App] Disconnect Account Success',
  props<{ appId: string; account: number }>()
)
export const disconnectAccountFailure = createAction('[App] Disconnect Account Failure', props<{ error: Error }>())
